var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 77,
    viewBox: "0 0 90 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dynamc imaging-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.4 42.3996C2.4 42.3996 0 39.9996 0 36.9996V6.49961C0 3.49961 2.4 1.09961 5.4 1.09961H84.6C86 1.09961 87.4 1.69961 88.4 2.69961C89.4 3.69961 90 5.09961 90 6.49961V36.9996C90 39.9996 87.6 42.3996 84.6 42.3996H5.4ZM5.4 2.79961C3.3 2.79961 1.7 4.49961 1.7 6.49961V36.9996C1.7 39.0996 3.4 40.6996 5.4 40.6996H84.6C86.7 40.6996 88.3 38.9996 88.3 36.9996V6.49961C88.3 4.39961 86.6 2.79961 84.6 2.79961H5.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 25.7C9.80019 25.7 9.60019 25.6 9.40019 25.4L6.3002 22.3C6.0002 22 6.0002 21.5 6.3002 21.2L9.3002 18.2C9.5002 18 9.70019 18 9.90019 18C10.1002 18 10.3002 18.1 10.5002 18.2C10.8002 18.5 10.8002 19.1 10.5002 19.4L8.5002 21.4C8.4002 21.5 8.3002 21.7 8.3002 21.9C8.3002 22.1 8.4002 22.3 8.5002 22.4L10.5002 24.4C10.7002 24.6 10.8002 24.9 10.7002 25.2C10.6002 25.5 10.4002 25.7 10.1002 25.8C10.1002 25.6 10.1002 25.7 10.0002 25.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9999 25.6994C79.8999 25.6994 79.8999 25.6994 79.7999 25.6994C79.4999 25.5994 79.2999 25.3994 79.1999 25.0994C79.0999 24.7994 79.1999 24.4994 79.3999 24.2994L81.3999 22.2994C81.6999 21.9994 81.6999 21.5994 81.3999 21.2994L79.3999 19.2994C79.0999 18.9994 79.0999 18.3994 79.3999 18.0994C79.5999 17.8994 79.7999 17.8994 79.9999 17.8994C80.1999 17.8994 80.3999 17.9994 80.5999 18.0994L83.5999 21.0994C83.8999 21.3994 83.8999 21.9994 83.5999 22.2994L80.5999 25.2994C80.4999 25.5994 80.1999 25.6994 79.9999 25.6994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3 34.7992C33.8 34.7992 33.5 34.3992 33.5 33.9992C33.5 33.4992 33.9 33.1992 34.3 33.1992C34.8 33.1992 35.1 33.5992 35.1 33.9992C35.2 34.3992 34.8 34.7992 34.3 34.7992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0002 34.7992C44.5002 34.7992 44.2002 34.3992 44.2002 33.9992C44.2002 33.4992 44.6002 33.1992 45.0002 33.1992C45.5002 33.1992 45.8002 33.5992 45.8002 33.9992C45.8002 34.3992 45.5002 34.7992 45.0002 34.7992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6999 34.7992C55.1999 34.7992 54.8999 34.3992 54.8999 33.9992C54.8999 33.4992 55.2999 33.1992 55.6999 33.1992C56.1999 33.1992 56.4999 33.5992 56.4999 33.9992C56.4999 34.3992 56.0999 34.7992 55.6999 34.7992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.9 63.6998C1.7 63.6998 0 61.9998 0 59.7998V50.6998C0 48.5998 1.7 46.7998 3.9 46.7998H13C15.1 46.7998 16.9 48.4998 16.9 50.6998V59.7998C16.9 61.8998 15.2 63.6998 13 63.6998H3.9ZM3.9 48.4998C2.7 48.4998 1.7 49.4998 1.7 50.6998V59.7998C1.7 60.9998 2.7 61.9998 3.9 61.9998H13C14.2 61.9998 15.2 60.9998 15.2 59.7998V50.6998C15.2 49.4998 14.2 48.4998 13 48.4998H3.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.2999 63.6998C26.1999 63.6998 24.3999 61.9998 24.3999 59.7998V50.6998C24.3999 48.5998 26.0999 46.7998 28.2999 46.7998H37.3999C39.4999 46.7998 41.2999 48.4998 41.2999 50.6998V59.7998C41.2999 61.8998 39.5999 63.6998 37.3999 63.6998H28.2999ZM28.2999 48.4998C27.0999 48.4998 26.0999 49.4998 26.0999 50.6998V59.7998C26.0999 60.9998 27.0999 61.9998 28.2999 61.9998H37.3999C38.5999 61.9998 39.5999 60.9998 39.5999 59.7998V50.6998C39.5999 49.4998 38.5999 48.4998 37.3999 48.4998H28.2999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.4 30.1998C38.3 30.1998 36.5 28.4998 36.5 26.2998V17.1998C36.5 15.0998 38.2 13.2998 40.4 13.2998H49.5C51.6 13.2998 53.4 14.9998 53.4 17.1998V26.2998C53.4 28.3998 51.7 30.1998 49.5 30.1998H40.4ZM40.4 14.9998C39.2 14.9998 38.2 15.9998 38.2 17.1998V26.2998C38.2 27.4998 39.2 28.4998 40.4 28.4998H49.5C50.7 28.4998 51.7 27.4998 51.7 26.2998V17.1998C51.7 15.9998 50.7 14.9998 49.5 14.9998H40.4Z",
    fill: "#F69A4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M52.6002 63.6998C50.5002 63.6998 48.7002 61.9998 48.7002 59.7998V50.6998C48.7002 48.5998 50.4002 46.7998 52.6002 46.7998H61.7002C63.8002 46.7998 65.6002 48.4998 65.6002 50.6998V59.7998C65.6002 61.8998 63.9002 63.6998 61.7002 63.6998H52.6002ZM52.6002 48.4998C51.4002 48.4998 50.4002 49.4998 50.4002 50.6998V59.7998C50.4002 60.9998 51.4002 61.9998 52.6002 61.9998H61.7002C62.9002 61.9998 63.9002 60.9998 63.9002 59.7998V50.6998C63.9002 49.4998 62.9002 48.4998 61.7002 48.4998H52.6002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M77.0001 63.6998C74.9001 63.6998 73.1001 61.9998 73.1001 59.7998V50.6998C73.1001 48.5998 74.8001 46.7998 77.0001 46.7998H86.1001C88.2001 46.7998 90.0001 48.4998 90.0001 50.6998V59.7998C90.0001 61.8998 88.3001 63.6998 86.1001 63.6998H77.0001ZM77.0001 48.4998C75.8001 48.4998 74.8001 49.4998 74.8001 50.6998V59.7998C74.8001 60.9998 75.8001 61.9998 77.0001 61.9998H86.1001C87.3001 61.9998 88.3001 60.9998 88.3001 59.7998V50.6998C88.3001 49.4998 87.3001 48.4998 86.1001 48.4998H77.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4001 69.7992C1.9001 69.7992 1.6001 69.3992 1.6001 68.9992C1.6001 68.5992 2.0001 68.1992 2.4001 68.1992H14.6001C15.1001 68.1992 15.4001 68.5992 15.4001 68.9992C15.4001 69.3992 15.0001 69.7992 14.6001 69.7992H2.4001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4001 75.8998C4.9001 75.8998 4.6001 75.4998 4.6001 75.0998C4.6001 74.6998 5.0001 74.2998 5.4001 74.2998H11.5001C12.0001 74.2998 12.3001 74.6998 12.3001 75.0998C12.3001 75.4998 11.9001 75.8998 11.5001 75.8998H5.4001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6999 69.7992C26.1999 69.7992 25.8999 69.3992 25.8999 68.9992C25.8999 68.5992 26.2999 68.1992 26.6999 68.1992H38.8999C39.3999 68.1992 39.6999 68.5992 39.6999 68.9992C39.6999 69.3992 39.2999 69.7992 38.8999 69.7992H26.6999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8 75.8998C29.3 75.8998 29 75.4998 29 75.0998C29 74.6998 29.4 74.2998 29.8 74.2998H35.9C36.4 74.2998 36.7 74.6998 36.7 75.0998C36.7 75.4998 36.3 75.8998 35.9 75.8998H29.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0998 69.7992C50.5998 69.7992 50.2998 69.3992 50.2998 68.9992C50.2998 68.5992 50.6998 68.1992 51.0998 68.1992H63.2998C63.7998 68.1992 64.0998 68.5992 64.0998 68.9992C64.0998 69.3992 63.6998 69.7992 63.2998 69.7992H51.0998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0998 75.8998C53.5998 75.8998 53.2998 75.4998 53.2998 75.0998C53.2998 74.6998 53.6998 74.2998 54.0998 74.2998H60.1998C60.6998 74.2998 60.9998 74.6998 60.9998 75.0998C60.9998 75.4998 60.5998 75.8998 60.1998 75.8998H54.0998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5002 69.7992C75.0002 69.7992 74.7002 69.3992 74.7002 68.9992C74.7002 68.5992 75.1002 68.1992 75.5002 68.1992H87.7002C88.2002 68.1992 88.5002 68.5992 88.5002 68.9992C88.5002 69.3992 88.1002 69.7992 87.7002 69.7992H75.5002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5002 75.8998C78.0002 75.8998 77.7002 75.4998 77.7002 75.0998C77.7002 74.6998 78.1002 74.2998 78.5002 74.2998H84.6002C85.1002 74.2998 85.4002 74.6998 85.4002 75.0998C85.4002 75.4998 85.0002 75.8998 84.6002 75.8998H78.5002Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.c7acea36dc26c4866a16aea33fbd6078.svg";
export { ForwardRef as ReactComponent };